import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { AccountsUsersSpecializedRolesPermissions } from './accounts-users-specialized-roles.permissions';

export class AccountsUsersSpecializedRolesPermissionsPermissions {
    static GroupName = `${AccountsUsersSpecializedRolesPermissions.GroupName}.Permissions`;

    static getPermissions = getGroupPermissionFactory(AccountsUsersSpecializedRolesPermissionsPermissions.GroupName);

    static Permissions = {
        Assign: AccountsUsersSpecializedRolesPermissionsPermissions.getPermissions('Assign'),
        Revoke: AccountsUsersSpecializedRolesPermissionsPermissions.getPermissions('Revoke')
    };
}
